<!--  -->
<template>
  <div class="">
    <div class="card">
      <!-- 商品列表 -->
      <div class="typeHeader LR_center">
        <div>
          <el-input
            style="width: 314px"
            placeholder="请输入中文品名"
            v-model="name"
            clearable
            @clear="getgoodsData()"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              type="primary"
              @click="getgoodsData(true)"
              >搜索</el-button
            >
          </el-input>
        </div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            plain
            @click="addNewGoods()"
            >新增商品</el-button
          >
          <el-button
            @click="excelVisible = true"
            type="primary"
            icon="el-icon-download"
            plain
            >导入商品</el-button
          >
        </div>
      </div>
      <div class="countTable" style="margin-top: 30px">
        <el-table
          ref="multipleTable"
          border
          :data="goodsLabel"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column prop="country" align="center" label="目的国">
          </el-table-column>
          <el-table-column label="中文名称" align="center" width="120">
            <template slot-scope="scope">{{ scope.row.namec }}</template>
          </el-table-column>
          <el-table-column
            prop="namee"
            label="英文品名"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="goodstype" align="center" label="商品类型">
          </el-table-column>
          <el-table-column prop="model" align="center" label="型号">
          </el-table-column>
          <el-table-column prop="brand" align="center" label="品牌">
          </el-table-column>
          <el-table-column prop="declaredValue" align="center" label="货值(USD)">
          </el-table-column>
          <el-table-column prop="hsCode" align="center" label="海关编码">
          </el-table-column>
          <el-table-column prop="materialc" align="center" label="材质">
          </el-table-column>
          <el-table-column prop="purposec" align="center" label="用途">
          </el-table-column>

          <el-table-column label="带电?" align="center" width="80">
            <template slot-scope="scope">
              {{ scope.row.isHasBattery ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column label="带磁?" align="center" width="80">
            <template slot-scope="scope">
              {{ scope.row.isHasMagnetic ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column label="是否液体/粉末" align="center" width="80">
            <template slot-scope="scope">
              {{ scope.row.isPowderLiquid ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column label="商品图片" align="center" prop="">
            <template slot-scope="scope">
              <div v-viewer>
                <img
                  v-if="scope.row.picUrl"
                  :src="scope.row.picUrl"
                  class="table-column__goods-cover"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="销售链接" align="center" prop="salesUrl">
            <template slot-scope="scope">
              <a
                v-if="scope.row.salesUrl"
                class="el-link el-link--info"
                :href="scope.row.salesUrl"
                target="_blank"
              >
                {{ scope.row.salesUrl }}
              </a>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="clickGoodsEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="text"
                style="color: #999"
                @click="delGoodItem(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 20px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20,30,40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalPage"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 新增编辑商品弹窗 -->
      <el-dialog
        title="新增商品"
        :before-close="close"
        :visible.sync="showGoodsEdit"
        width="870px"
        :close-on-click-modal="false"
      >
        <el-form
          :model="addGoodForm"
          ref="addGoodForm"
          class="add-goods__form"
          label-width="130px"
          size="small"
        >
          <el-form-item
            label="国家"
            prop="countryId"
            :rules="formRules.require"
            class="add-goods__form-item"
          >
            <el-select
              v-model="addGoodForm.countryId"
              @change="countryIdChange"
              class="add-goods__form-input"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in countryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <br />
          <el-form-item
            label="中文品名"
            prop="namec"
            :rules="formRules.require"
            class="add-goods__form-item"
          >
            <el-input
              v-model="addGoodForm.namec"
              class="add-goods__form-input"
              placeholder="请输入中文品名"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            label="英文品名"
            prop="namee"
            :rules="formRules.require"
            class="add-goods__form-item"
          >
            <el-input
              v-model="addGoodForm.namee"
              class="add-goods__form-input"
              placeholder="请输入英文品名"
            >
            </el-input>
          </el-form-item>
          <br />
          <!-- :rules="formRules.require" -->
          <el-form-item
            label="货物类型"
            prop="goodstypeid"
            class="add-goods__form-item"
            :rules="formRules.require"
          >
            <el-select
              v-model="addGoodForm.goodstypeid"
              class="add-goods__form-input"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in goodsTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- :rules="formRulesModel" -->
          <el-form-item label="型号" prop="model" class="add-goods__form-item">
            <el-input
              v-model="addGoodForm.model"
              class="add-goods__form-input"
              placeholder="请输入型号"
            >
            </el-input>
          </el-form-item>
          <br />
          <el-form-item
            label="品牌"
            prop="brand"
            :rules="formRulesBrand"
            class="add-goods__form-item"
          >
            <el-input
              v-model="addGoodForm.brand"
              class="add-goods__form-input"
              placeholder="请输入品牌"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            label="货值"
            prop="declaredValue"
            :rules="formRules.require"
            class="add-goods__form-item"
          >
            <el-input
              v-model="addGoodForm.declaredValue"
              type="number"
              class="add-goods__form-input input-number__no-arrows"
              placeholder="请输入货值"
            >
              <i type="text" style="font-style: normal" slot="suffix">USD</i>
              >
            </el-input>
          </el-form-item>
          <br />
          <el-form-item
            label="海关编码"
            prop="materialc"
            :rules="formRules.no"
            class="add-goods__form-item"
          >
            <el-input
              v-model="addGoodForm.hsCode"
              class="add-goods__form-input"
              placeholder="请输入海关编码"
            >
            </el-input>
          </el-form-item>
          <!--  :rules="formRulesMaterialc" -->
          <el-form-item
            label="材质"
            prop="materialc"
            class="add-goods__form-item"
          >
            <el-input
              v-model="addGoodForm.materialc"
              class="add-goods__form-input"
              placeholder="请输入材质"
            >
            </el-input>
          </el-form-item>
          <br />
          <!-- :rules="formRulesPurposec" -->
          <el-form-item
            label="用途"
            prop="purposec"
            class="add-goods__form-item"
          >
            <el-input
              v-model="addGoodForm.purposec"
              class="add-goods__form-input"
              placeholder="请输入用途"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            label="是否带电"
            prop="isHasBattery"
            :rules="formRules.require"
            class="add-goods__form-item"
          >
            <el-select
              v-model="addGoodForm.isHasBattery"
              class="add-goods__form-input"
              size="mini"
              placeholder="请选择"
            >
              <el-option label="是" :value="true"> </el-option>
              <el-option label="否" :value="false"> </el-option>
            </el-select>
          </el-form-item>
          <br />
          <el-form-item
            label="是否带磁"
            prop="isHasMagnetic"
            :rules="formRules.require"
            class="add-goods__form-item"
          >
            <el-select
              v-model="addGoodForm.isHasMagnetic"
              class="add-goods__form-input"
              size="mini"
              placeholder="请选择"
            >
              <el-option label="是" :value="true"> </el-option>
              <el-option label="否" :value="false"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否液体/粉末"
            prop="isPowderLiquid"
            :rules="formRules.require"
            class="add-goods__form-item"
          >
            <el-select
              v-model="addGoodForm.isPowderLiquid"
              class="add-goods__form-input"
              size="mini"
              placeholder="请选择"
            >
              <el-option label="是" :value="true"> </el-option>
              <el-option label="否" :value="false"> </el-option>
            </el-select>
          </el-form-item>
          <br />
          <!-- :rules="formRulesSalesUrl" -->
          <el-form-item
            label="销售链接"
            prop="salesUrl"
            class="add-goods__form-item"
          >
            <!--style="width: 806px;"-->
            <el-input
              v-model="addGoodForm.salesUrl"
              class="add-goods__form-input"
              placeholder="请输入销售链接"
            >
            </el-input>
          </el-form-item>
          <br />

          <el-form-item
            label="商品图片"
            prop="picUrl"
            ref="uploadGoodsCover"
            :rules="formRulesPicUrl"
            class="add-goods__form-item"
          >
            <el-upload
              class="avatar-uploader"
              action=""
              :auto-upload="false"
              :on-change="uploadImageChange"
              :before-upload="beforeAvatarUpload"
              :show-file-list="false"
            >
              <template v-if="addGoodForm.picUrl">
                <img :src="addGoodForm.picUrl" class="avatar" />
                <i
                  class="
                    avatar-uploader-icon avatar-uploader-delete
                    el-icon-delete
                  "
                  @click.stop="deleteGoodsCover"
                ></i>
              </template>
              <i
                v-else
                class="avatar-uploader-icon avatar-uploader-plus el-icon-plus"
              ></i>
            </el-upload>
          </el-form-item>
        </el-form>

        <div class="add-goods__action-row">
          <el-button @click="clickSaveGoods('addGoodForm')" type="primary">
            {{ GoodsCategory ? "确认新增" : "确认修改" }}
          </el-button>
        </div>
      </el-dialog>
      <!-- 新增编辑商品弹窗END -->

      <!-- Excel上传 -->
      <el-dialog
        title="文件上传"
        :visible.sync="excelVisible"
        width="70%"
        center
        :before-close="beforeClose"
        :close-on-click-modal="false"
      >
        <!--  :show-file-list="false" 是否显示上传文件的list -->
        <!-- drag  是否可拖拽 -->
        <!--  multiple 是否上传多文件 -->
        <!--   :action="upUrl" 上传地址 -->
        <el-upload
          style="text-align: center"
          :show-file-list="false"
          :on-error="handleError"
          :on-success="handleSuccess"
          :before-upload="handleBeforeUpload"
          class="upload-demo"
          drag
          :http-request="uploadSectionFile"
          action=""
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">仅限xls和xlsx文件</div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button style="margin-right: 20px" size="mini" @click="cancel()"
            >取 消</el-button
          >

          <el-button size="mini" @click="donwLoadTemplate" type="success"
            >下载模板</el-button
          >
        </span>

        <el-table
          style="margin-top: 20px; width: 100%"
          v-if="resultList.length"
          :data="resultList"
          border
        >
          <el-table-column prop="lineNumber" label="行数" width="180">
          </el-table-column>
          <el-table-column prop="isSuccess" label="是否成功" width="180">
            <template slot-scope="scope">
              {{ scope.row.isSuccess ? "成功" : "失败" }}
            </template>
          </el-table-column>
          <el-table-column prop="failureReason" label="描述"> </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import {
  rulesNotEmpty,
  getElFormValidateValue,
  notifyFormValidateErrorInfo,
} from "@/assets/js/formRules";

function baseDataEditGoods() {
  return {
    countryId: "", //国家ID
    brand: "", //品牌
    // customerid: this.sessionGetUserInfo().customerid, //客户id
    declaredValue: "", //货值
    // file:"",//file
    goodstypeid: "", //货物类型id
    hsCode: "", //海关编码
    id: "", //
    isHasBattery: "", //是否带电
    isHasMagnetic: "", //是否带磁
    isPowderLiquid: "", //是否液体粉末
    materialc: "", //中文材质
    model: "", //型号
    namec: "", //商品中文名称
    namee: "", //商品英文名称
    picUrl: "", //商品图片
    purposec: "", //中文用途
    salesUrl: "", //销售链接
  };
}
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      // 上传成功后返回的list
      resultList: [],
      // 搜索
      name: "",
      countryProp: { label: "name", value: "id", children: "children" },
      totalPage: 0,
      currentPage: 1,
      pageSize: 10,

      goodstypelist: [],
      goodsTypeId: "",
      excelVisible: false,
      Sgodname: "",
      goodsLabel: [],
      /*编辑弹窗*/
      countryList: [], //编辑弹窗：国家列表
      goodsTypeList: [], //编辑弹窗：商品类型列表
      addGoodForm: baseDataEditGoods(),
      showGoodsEdit: false,
      goodsTypeShow: false,
      GoodsCategory: true, //true是新增 false是修改
      /*图片上传*/
      imageFile: null,
      /*校验*/
      formRules: {
        no: [{ trigger: "blur", required: false }],
        require: [rulesNotEmpty()],
        location: [
          rulesNotEmpty(),
          { trigger: "blur", pattern: /^.{4,30}$/, message: "6-30个字符" },
        ],
      },
    };
  },
  //监听属性 类似于data概念
  computed: {
    nowCountryCode() {
      // "阿拉伯联合酋长国" AE
      // "沙特阿拉伯"  SA
      // "美国" US
      let id = this.addGoodForm.countryId;
      let code = "";
      let country = this.countryList.find((res) => res.value === id);
      if (country) code = country.code || "";
      return code;
    },
    isCountryALQ() {
      //阿联酋
      return this.nowCountryCode === "AE";
    },
    isCountryST() {
      //沙特
      return this.nowCountryCode === "SA";
    },
    isCountryMG() {
      //美国
      return this.nowCountryCode === "US";
    },
    // formRulesModel(){//型号
    //   if(this.isCountryALQ) return this.formRules.no;
    //   return this.formRules.require;
    // },
    formRulesBrand() {
      //品牌
      if (this.isCountryALQ) return this.formRules.no;
      return this.formRules.require;
    },
    // formRulesMaterialc(){//材质
    //   if(this.isCountryALQ) return this.formRules.no;
    //   return this.formRules.require;
    // },
    // formRulesPurposec(){//用途
    //   if(this.isCountryALQ) return this.formRules.no;
    //   return this.formRules.require;
    // },
    // formRulesSalesUrl(){//销售链接
    //   return this.formRules.no
    //   // if(this.isCountryALQ || this.isCountryST) return this.formRules.no;
    //   // return this.formRules.require;
    // },
    formRulesPicUrl() {
      //商品图片
      if (this.isCountryALQ) return this.formRules.no;
      return this.formRules.require;
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    cancel() {
      this.excelVisible = false;
      this.resultList = [];
      this.getgoodsData();
    },
    beforeClose() {
      this.excelVisible = false;
      this.resultList = [];
      this.getgoodsData();
    },

    changeGStype(id, index) {
      //切换货物类型
    },
    handleSizeChange(val) {
      // 只要换页数就直接返回1页
      this.pageSize = val;
      this.getgoodsData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getgoodsData();
    },
    getInner(arr) {
      if (arr == null) {
        return null;
      }
      return arr.map((item) => {
        return {
          label: item.name,
          value: item.id,
          children: this.getInner(item.children),
        };
      });
    },
    // todo
    getCountryList() {
      this.axios
        .get(`/fbxData/getCountryGoodsType`)
        .then((res) => {
          if (res.data.code == 200) {
            this.countryList = res.data.datas.map((item) => {
              return {
                code: item.code,
                label: item.name,
                value: item.id,
                children: this.getInner(item.children),
              };
            });
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 选择仓库后
    MyhandleChange(value, s) {
      // console.log(value,s);
      this.goodsTypeId = value[1];
      this.addGoodForm.goodstypeid = value[1];
      this.getGoodstypelist();
    },
    /*选择国家*/
    countryIdChange(value) {
      this.addGoodForm.goodstypeid = "";
      let list = [];
      let target = this.countryList.find((res) => res.value === value);
      if (target) {
        list = target.children || [];
      }
      this.goodsTypeList = list;
    },
    // 上传下载相关 start
    // 自定义上传
    uploadSectionFile(params) {
      // console.log(params);
      let form = new FormData();
      form.append("file", params.file);
      this.axios
        .post(`/fbxData/importFBXCustomerGoods`, form)
        .then((res) => {
          if (res.data.code == 200) {
            // console.log(res.data.datas);
            this.resultList = res.data.datas;
          } else {
            this.$message("请选择正确的模板");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //失败时的方法
    handleError(err) {
      this.$message.info(err.data);
    },
    //成功时的方法
    handleSuccess(response) {
      //  console.log(response);
      if (response.isSuccess) {
        this.$message.success(response.error);
        this.getListByParam();
        return;
      }
      this.$message.info(response.error);
    },
    //上传之前校验的方法
    handleBeforeUpload(file) {
      // 校验
      let legalName = ["xlsx", "xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        // console.log(legalName.includes(name));
      } else {
        this.$message.info("文件格式不对，仅限xls和xlsx");
        return false;
      }
    },
    donwLoadTemplate() {
      this.axios
        .get(
          `/fbxData/getFBXCustomerGoodsTemplate`,

          {
            responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
          }
        )
        .then((res) => {
          let a = document.createElement("a");
          let blob = new Blob([res.data]);
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", "模板.xls");
          a.click();
          // console.log(objectUrl);
          URL.revokeObjectURL(objectUrl); // 释放内存
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 上传下载相关end
    getgoodsData(type) {
      if (type) {
        this.currentPage = 1;
      }
      //获取商品列表
      let params = {
        customerid: this.sessionGetUserInfo()
          .customerid, //客户id,
        name: this.name,
        // goodstypeid: 0,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      this.axios
        .post(`/fbxData/pageFbxCustomerGoodsList`, params)
        .then((res) => {
          if (res.data.code == "200") {
            // res.data.datas.forEach((item) => {
            //   this.$set(item, "num", 1);
            // });
            this.goodsLabel = res.data.data.list;
            this.totalPage = res.data.data.total;
          } else {
          }
        })
        .catch((res) => {});
    },
    //-----------
    getGoodstypelist() {
      //商品类型
      //   this.axios
      //     .get(`/filedata/findFBAGoodTypeList?warehouseId=${this.countryId[1]}`)
      //     .then((res) => {
      //       if (res.data.code == "200") {
      //         this.goodstypelist = res.data.datas;
      //       } else {
      //       }
      //     })
      //     .catch((res) => {});
    },
    handleSelectionChange(val) {
      this.thatGoodslist = val;
    },
    /**
     * 上传图片
     */
    uploadImageChange(file, fileList) {
      this.addGoodForm.picUrl = URL.createObjectURL(file.raw);
      this.imageFile = file;
    },
    beforeAvatarUpload(file) {
      const isJPG = ["image/png", "image/jpeg"].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    deleteGoodsCover() {
      this.addGoodForm.picUrl = "";
      this.imageFile = null;
      let $uploadGoodsCover = this.$refs.uploadGoodsCover;
      if (typeof $uploadGoodsCover.clearFiles === "function") {
        $uploadGoodsCover.clearFiles();
      } else {
        // $uploadGoodsCover.resetField();
      }
    },
    /**
     * 获取图片
     */
    windowOpenImage(src) {
      if (!src) return false;
      let newView = window.open();
      newView.document.write(`<img src="${src}"/>`);
      // src = src.replace(/\.(png|jpg|jpeg)$/ig,'');
      // window.open(src);
    },
    /**
     * 删除商品
     */
    delGoodItem(index, item) {
      this.$confirm("确定删除此商品信息吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: item.id,
          };

          this.axios
            .post(
              `/busFbx/deleteFbxCustomerGoodsCategory`,
              qs.stringify(params)
            )
            .then((res) => {
              if (res.data.code == "200") {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });

                this.getgoodsData();
              } else {
              }
            })
            .catch((res) => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    /**
     * 新增商品
     */
    addNewGoods() {
      // console.log(val)
      //新增商品信息
      this.showGoodsEdit = true;
      this.GoodsCategory = true;
    },
    clickGoodsEdit(index, item) {
      // console.log(item);
      this.GoodsCategory = false;
      this.showGoodsEdit = true;

      /* 其他编辑参数 */
      let needKeys = {
        countryId: "countryId",
        brand: "brand",
        customerid: this.sessionGetUserInfo()
          .customerid, //客户id,
        declaredValue: "declaredValue",
        // "file": "file",
        goodstypeid: "goodstypeid",
        hsCode: "hsCode",
        id: "id",
        isHasBattery: "isHasBattery",
        isHasMagnetic: "isHasMagnetic",
        isPowderLiquid: "isPowderLiquid",
        materialc: "materialc",
        model: "model",
        namec: "namec",
        namee: "namee",
        picUrl: "picUrl",
        purposec: "purposec",
        salesUrl: "salesUrl",
      };
      this.countryIdChange(item.countryId);
      this.addGoodForm.customerid = this.sessionGetUserInfo().customerid; //客户id,
      Object.keys(needKeys).forEach((key) => {
        let itemKey = needKeys[key];
        this.addGoodForm[key] = item[itemKey];
      });
    },
    close() {
      this.showGoodsEdit = false;
      this.addGoodForm = baseDataEditGoods();
    },
    clickSaveGoods(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          let form = this.$refs[formName];
          let results = getElFormValidateValue(form);
          return notifyFormValidateErrorInfo.call(this, results);
        }
        // this.$message.success('提交表单');
        this.saveEditGoods();
      });
    },
    saveEditGoods(formName) {
      // 校验是否选了类型
      if (this.addGoodForm.goodstypeid == 0) {
        return this.$message.info("请选择货物类型");
      }
      if (this.addGoodForm.namec == "") return this.$message("请输入中文品名");
      if (this.addGoodForm.namee == "") return this.$message("请输入英文品名");
      // if (this.addGoodForm.declaredValue == "")
      //   return this.$message("请输入货值");
      let declaredValue = parseFloat(this.addGoodForm.declaredValue) || -1;
      if (declaredValue && declaredValue <= 0)
        return this.$message("货值不能小于0");
      // let params = Object.assign({},this.addGoodForm);
      let params = new FormData();
      Object.keys(this.addGoodForm).forEach((key) => {
        let value = this.addGoodForm[key];
        if ([undefined, null, "null"].includes(value)) value = "";
        params.append(key, value);
      });
      if (this.imageFile && this.imageFile.raw) {
        params.append("file", this.imageFile.raw);
        if (params.has("picUrl")) params.delete("picUrl");
        params.append("picUrl", "");
      }
     
      this.axios
        .post(`/busFbx/addOrUpdateFbxCustomerGoodsCategory`, params)
        .then((res) => {
          if (res.data.code == "200") {
            this.showGoodsEdit = false;
            this.countryId = ["", ""];

            this.getgoodsData();
            this.$message({
              message: "成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.message,
              type: "info",
            });
          }
        })
        .catch((res) => {});
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getgoodsData();
    // this.getGoodstypelist();
    this.getCountryList();
    // this.getPopList();
  },
};
</script>
<style  scoped>
/*编辑商品表单*/
.add-goods__form {
  display: block;
  width: 100%;
  margin-right: 0;
}
.add-goods__form-item {
  display: inline-block;
  width: 400px;
}
.add-goods__form-input {
  width: 100%;
}
.add-goods__action-row {
  text-align: center;
}
/*上传图片*/
.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader >>> .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-plus {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar-uploader-delete {
  position: absolute;
  z-index: 1;
  top: 6px;
  right: 6px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background-color: white;
  border-radius: 50%;
  color: red;
  font-size: 12px;
}
.avatar-uploader-delete:hover {
  background-color: red;
  color: white;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.table-column__goods-cover {
  width: 60px;
  height: 60px;
  display: block;
  border: none;
  cursor: pointer;
  object-fit: cover;
}
/*其他*/

.el-table >>> th.gutter {
  display: table-cell !important;
}
.card {
  padding: 30px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
}

.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FbaGoodsBase.vue